// used for dashboard widgets
(function () {
	'use strict';

	angular.module('app.dashboard')
		.config(metricWidgetConfig)
		.controller('metric', metric);

	function metricWidgetConfig(dashboardProvider) {
		var widgetMetric = {
			name: 'Metrics',
			description: 'Displays charts for selected metric',
			thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/metric.png',
			categories: ['All', 'Metrics'],
			config: {},
			slideshowView: true,
			isActive: true,
			templateUrl: '/application/f/dashboard/widgets/metric.html',
			drillDownUrl: '/application/f/home.html#/lean-projects/metric-view?drilldown=1',
			reload: true,
			isDrillDown: true,
			isEditable: true,
			isPrintable: true,
			resolve: {
				title: function (config) {
					if (config.title) {
						return config.title;
					}
				},
				type: function (config) {
					if (config.type) {
						return config.type;
					}
				},
				metricNdx: function (config) {
					if (config.metricNdx) {
						return config.metricNdx;
					}
				},
				crossSiteName: function (config) {
					if (config.crossSiteName) {
						return config.crossSiteName;
					}
				},
				axis: function (config) {
					if (config.axis) {
						return config.axis;
					}
				}
			}
		};
		// register Metric Widgets
		dashboardProvider
			.widget('metric', angular.extend({
				controller: 'metric'
			}, widgetMetric));
	}

	function metric($rootScope, $scope, $timeout, $q, URLS, getJsonData, metricService, metricNdx, crossSiteName, type,
			dashboardFilterInitializationService, performanceDashboardDescription, formatterService,
			pageTimingService, $translate, leanFilterService, storeService, $experiments) {

		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.slideshowView = $rootScope.slideshowView;
		$scope.printView = $rootScope.printView;
		$scope.metric = {};
		$scope.metricChosen = false;
		$scope.current = {};
		$scope.delta = {};
		$scope.hideOverview = false;
		$scope.useConfig = false;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
		$scope.$parent.$parent.showViewReport = true;
		$scope.$parent.$parent.isDrillDown = true;
		$scope.$parent.$parent.editTitle = 'Edit Metric configuration';
		// This is a crime
		if ($scope.$parent.$parent.$parent.model) {
			$scope.$parent.$parent.nonRemovable = $scope.$parent.$parent.$parent.model.baseReportName === performanceDashboardDescription;
			$scope.showSelectMetric = $scope.$parent.$parent.$parent.model.baseReportName !== performanceDashboardDescription;
		} else {
			$scope.$parent.$parent.nonRemovable = false;
			$scope.showSelectMetric = false;
		}

		$scope.tooManyCategories = false;
		if (!$scope.$parent.content.defaultDrillDownUrl) {
			$scope.$parent.content.defaultDrillDownUrl = $scope.$parent.content.drillDownUrl;
		}

		function checkForMetrics() {
			if (metricNdx) {
				var selectedMetric = metricService.getSelectedMetric($scope.metrics, metricNdx, crossSiteName);
				var hideChart = true;
				if (selectedMetric !== null) {
					$scope.metric = selectedMetric;
					$scope.metricName = selectedMetric.name;
					$scope.metricChosen = true;
					$scope.$parent.$parent.metricNdx = metricNdx;
					getConfigForNdx(metricNdx);
					$scope.$parent.$parent.definition.config.title = selectedMetric.name;
					hideChart = false;
					generateChart(selectedMetric);
				} else {
					updateMetricConfig(null);
				}
				$scope.metricSelect = hideChart;
				$scope.$parent.$parent.hidePencil = hideChart;
			} else {
				$scope.$parent.$parent.hidePencil = true;
				$scope.metricSelect = true;
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView && !$scope.printView) {
					pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
			}
		}

		function getConfigForNdx(ndx) {
			var configExists = false;
			if ($scope.model && $scope.model.config && $scope.model.config.axis) {
				var yAxis = $scope.model.config.axis;
				if (yAxis[ndx]) {
					configExists = true;
					$scope.metricMinAxisCalcType = yAxis[ndx].yAxisMinCalcType;
					$scope.metricMaxAxisCalcType = yAxis[ndx].yAxisMaxCalcType;
					$scope.metricMinAxisValue = yAxis[ndx].yAxisMinFixedValue;
					$scope.metricMaxAxisValue = yAxis[ndx].yAxisMaxFixedValue;
				}
			}
			if (!configExists) {
				$scope.metricMinAxisCalcType = $scope.metric.yAxisMinCalcType;
				$scope.metricMaxAxisCalcType = $scope.metric.yAxisMaxCalcType;
				$scope.metricMinAxisValue = $scope.metric.yAxisMinFixedValue;
				$scope.metricMaxAxisValue = $scope.metric.yAxisMaxFixedValue;
			}
			if ($scope.metric.componentAxes && $scope.metric.componentAxes.length) {
				$scope.allowAxesEdit = false;
			} else {
				$scope.allowAxesEdit = true;
			}

			// Check for summary
			try {
				var config = JSON.parse($scope.model.configStr);
				if (_.has(config, 'summary') && config.summary === false) {
					$scope.hideOverview = true;
				}
			} catch (err) {
				configExists = false;
			}

			$scope.useConfig = configExists;
		}

		function populateMetrics() {
			if ($scope.$parent.$parent.$parent.metricDropdownList &&
				$scope.$parent.$parent.$parent.metricDropdownList.length) {
				$scope.metrics = $scope.$parent.$parent.$parent.metricDropdownList;
				setNameAndCreateListOfUniqueMetrics($scope.metrics);
				checkForMetrics();
			} else {
				var url = URLS.host + String.format(URLS.widgetMetrics, $scope.leanFilterService.getFactoryList());
				getJsonData.get(url).then(
					function (d) {
						$scope.metrics = d;
						setNameAndCreateListOfUniqueMetrics($scope.metrics);
						checkForMetrics();
					},
					function (e) {
						$scope.error = e;
					}
				);
			}
		}

		function setNameAndCreateListOfUniqueMetrics(metrics) {
			$scope.uniqueMetrics = [];
			var addedNames = {};
			for (var i = metrics.length - 1; i >= 0; i--) {
				var metric = metrics[i];
				
				if ($scope.leanFilterService.getFactoryList(true).length > 1) {
					metric.name =  metric.crossSiteName;
				} else {
					metric.name = metric.name;
				}
				if (!addedNames.hasOwnProperty(metric.name)) {
					addedNames[metric.name] = 1;
					$scope.uniqueMetrics.push(metric);
				}
			}
			$scope.uniqueMetrics.sort(function (a, b) {
				if (a.name < b.name) {
					return -1;
				} else if (a.name > b.name) {
					return 1;
				} else {
					return 0;
				}
			});
		}

		function generateChart(metric) {
			if (!$scope.leanFilterService.isLoading()) {
				getChart(metric);
			} else {
				$timeout(function () {
					generateChart(metric);
				}, 100);
			}
		}
		function getChart(metric) {
			var componentMetricNdxs = [];
			var componentMetrics = [];
			var componentMetricAxes = [];
			var componentMetricVisibleTargets = [];
			if (metric && metric.componentMetrics && metric.componentMetrics.length) {
				componentMetricNdxs = metric.componentMetrics.split(',');
				componentMetricAxes = metric.componentAxes.split(',');
				componentMetricVisibleTargets = metric.componentShowTarget.split(',');
				for (var i = 0; i < componentMetricNdxs.length; i++) {
					for (var j = 0; j < $scope.metrics.length; j++) {
						if ($scope.metrics[j].ndx == componentMetricNdxs[i]) {
							componentMetrics.push($scope.metrics[j]);
						}
					}
				}
			}
			var factoryNdxsString = $scope.leanFilterService.getFactoryList();
			var timePeriod = $scope.filterService.getSelected('Time Period');
			if (!timePeriod) {
				timePeriod = 'current';
			}
			var qryParams = {};
			var vStreams = $scope.filterService.getSelected('Value Stream');
			vStreams = (!vStreams || !vStreams.length) ? '' : vStreams.toString();
			qryParams.timePeriod = timePeriod;
			qryParams.vstreams = vStreams;

			function isAllTargetsNull(data) {
				return data.every(function (elm) {
					return elm.value === null;
				});
			}

			function isAllTargetsNullOrZero(data) {
				return data.every(function (elm) {
					return elm.value === null || elm.value === 0;
				});
			}

			function isEmptyChart(data, metricConfig) {
				if (metricConfig && metricConfig.metricType === 'ProcurementLog' && (_.startsWith(metricConfig.name, 'Lean Project') || _.startsWith(metricConfig.name, 'Lean Projects: '))) {
					return data.results.length == 0 && (data.targets.length == 0 || isAllTargetsNullOrZero(data.targets));
				}
				return data.results.length == 0 && (data.targets.length == 0 || isAllTargetsNull(data.targets));
			}

			function setEmptyChart(metric) {
				$scope.empty = true;
				$scope.chartData = {
					'metricConfig': metric,
					'results': [],
					'targets': []
				};
			}

			if (!componentMetrics.length) {
				$scope.$parent.$parent.showViewReport = true;
				var filtersToAdd = {};
				if (factoryNdxsString && factoryNdxsString.length > 0) {
					filtersToAdd['factory'] = factoryNdxsString;
				}
				if (vStreams && vStreams.length > 0) {
					filtersToAdd['valueStream'] = vStreams;
				}
				if (!jQuery.isEmptyObject(filtersToAdd)) {
					$scope.$parent.content.drillDownUrl = addQueryParam($scope.$parent.content.defaultDrillDownUrl,
						null, filtersToAdd, false) + '&metricNdx=' + metric.ndx;
				} else {
					$scope.$parent.content.drillDownUrl = $scope.$parent.content.defaultDrillDownUrl + '&metricNdx=' + metric.ndx;
				}
				if (storeService.getState().reportSettings.config.showTrendline) {
					qryParams.trendLine = true;
				}
				var url = URLS.host + String.format(URLS.metricResults, factoryNdxsString, metric.ndx) +
					'?' + jQuery.param(qryParams);
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				getJsonData.get(url).then(
					function (d) {
						d.metricConfig = metric;
						d.metricConfig.metricId = metric.ndx;
						$scope.empty = false;
						$scope.tooManyCategories = false;
						if (isEmptyChart(d, metric)) {
							setEmptyChart(metric);
						} else {
							$scope.chartData = d;
						}
						$scope.$broadcast('event:' + (type || $scope.model.type) + 'Ctrl:getChart', null);
						if (!$scope.slideshowView && !$scope.printView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					},
					function (e) {
						$scope.tooManyCategories = false;
						$scope.metricSelect = false;
						setEmptyChart(metric);
						$scope.$broadcast('event:' + type + 'Ctrl:getChart', null);
						if (!$scope.slideshowView && !$scope.printView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					}
				);
			} else {
				var promiseList = [];
				$scope.$parent.$parent.showViewReport = false;
				for (var i = 0; i < componentMetrics.length; i++) {
					var tmpMetric = componentMetrics[i];
					if (storeService.getState().reportSettings.config.showTrendline) {
						qryParams.trendLine = true;
					}
					var url = URLS.host + String.format(URLS.metricResults, factoryIdList.toString(), tmpMetric.ndx) +
						'?' + jQuery.param(qryParams);
					var promise = getJsonData.get(url);
					promiseList.push(promise);
				}
				$q.all(promiseList).then(function (result) {
					$scope.chartData = {};
					$scope.chartData.results = [];
					$scope.chartData.targets = [];
					$scope.chartData.metricConfig = {};
					var metricOne = componentMetricAxes[0] == 'y' ? result[0] : result[1];
					var metricTwo = componentMetricAxes[0] == 'y' ? result[1] : result[0];
					$scope.chartData.currencySymbol = metricOne.currencySymbol;
					$scope.chartData.currency = metricOne.currency;
					var targetAxis = '';
					if (componentMetricVisibleTargets[0] == 1) {
						targetAxis = componentMetricAxes[0];
					}
					if (componentMetricVisibleTargets[1] == 1) {
						targetAxis = componentMetricAxes[1];
					}
					$scope.chartData.results = metricOne.results;
					$scope.chartData.targets = targetAxis == 'y2' ? metricTwo.targets : metricOne.targets;
					var metOneConfig = componentMetricAxes[0] == 'y' ? componentMetrics[0] : componentMetrics[1];
					var metTwoConfig = componentMetricAxes[0] == 'y' ? componentMetrics[1] : componentMetrics[0];
					// Combine results
					for (var i = 0; i < metricTwo.results.length; i++) {
						var ind = findMatchingXPoint(metricOne.results, metricTwo.results[i].date);
						if (ind == -1 || metTwoConfig.isCategorized) {
							var tmp = {};
							tmp.valueTwo = metricTwo.results[i].value;
							tmp.date = metricTwo.results[i].date;
							if (metricTwo.results[i].category) tmp.categoryTwo = metricTwo.results[i].category;
							$scope.chartData.results.push(tmp);
							if (!metTwoConfig.isCategorized) tmp.categoryTwo = null;
						} else {
							var obj = $scope.chartData.results[ind];
							obj.valueTwo = metricTwo.results[i].value;
							obj.categoryTwo = metricTwo.results[i].category;
						}
					}
					// Build metric config

					var combMetConfig = {};
					combMetConfig.displayResolutionType = 'Monthly';
					if (metOneConfig.displayResolutionType == 'Weekly' || metTwoConfig.displayResolutionType == 'Weekly') combMetConfig.displayResolutionType = 'Weekly';
					if (metOneConfig.displayResolutionType == 'Daily' || metTwoConfig.displayResolutionType == 'Daily') combMetConfig.displayResolutionType = 'Daily';
					combMetConfig.isCategorized = metOneConfig.isCategorized;
					combMetConfig.isCategorizedTwo = metTwoConfig.isCategorized;
					combMetConfig.chartType = metOneConfig.chartType;
					combMetConfig.chartTypeTwo = metTwoConfig.chartType;
					combMetConfig.goalType = metOneConfig.goalType;
					combMetConfig.goalTypeTwo = metTwoConfig.goalType;
					combMetConfig.yAxisLabel = metOneConfig.yAxisLabel;
					combMetConfig.yAxisLabelTwo = metTwoConfig.yAxisLabel;
					combMetConfig.displayType = metOneConfig.displayType;
					combMetConfig.displayTypeTwo = metTwoConfig.displayType;
					combMetConfig.yAxisMinFixedValue = metOneConfig.yAxisMinFixedValue;
					combMetConfig.yAxisMinFixedValueTwo = metTwoConfig.yAxisMinFixedValue;
					combMetConfig.yAxisMaxFixedValue = metOneConfig.yAxisMaxFixedValue;
					combMetConfig.yAxisMaxFixedValueTwo = metTwoConfig.yAxisMaxFixedValue;
					combMetConfig.yAxisMinCalcType = metOneConfig.yAxisMinCalcType;
					combMetConfig.yAxisMinCalcTypeTwo = metTwoConfig.yAxisMinCalcType;
					combMetConfig.yAxisMaxCalcType = metOneConfig.yAxisMaxCalcType;
					combMetConfig.yAxisMaxCalcTypeTwo = metTwoConfig.yAxisMaxCalcType;
					combMetConfig.comboChart = true;
					combMetConfig.axis = 'y';
					combMetConfig.axisTwo = 'y2';
					combMetConfig.targetsVisible = targetAxis;
					combMetConfig.crossSiteName = metric.crossSiteName;
					combMetConfig.name = metric.name;

					for (var i = 0; i < $scope.chartData.results.length; i++) {
						if (chartTypes[combMetConfig.chartType] == 'bar') {
							$scope.chartData.results[i].hasBar = $scope.chartData.results[i].value || $scope.chartData.results[i].value == 0;
						}
						if (chartTypes[combMetConfig.chartTypeTwo] == 'bar') {
							$scope.chartData.results[i].hasBar = $scope.chartData.results[i].valueTwo || $scope.chartData.results[i].valueTwo == 0;
						} else {
							$scope.chartData.results[i].hasBar = $scope.chartData.results[i].hasBar || false;
						}
					}
					$scope.empty = $scope.chartData.results.length == 0;
					$scope.chartData.metricConfig = combMetConfig;
					$scope.chartData.metricConfig.metricId = metric.ndx;
					$scope.$broadcast('event:' + (type || $scope.model.type) + 'Ctrl:getChart', null);
				}).catch(function (error) {
					$scope.error = error;
					$scope.empty = true;
					$scope.tooManyCategories = false;
					$scope.metricSelect = false;
					$scope.chartData = {
						'metricConfig': metric,
						'results': [],
						'targets': []
					};
				});
			}
		}

		function formatCurrentAndDelta(current, delta, previousDateKey, metricConfig, chartCurrencySymbol) {
			$scope.current.value = current;
			$scope.delta.value = delta;
			var currencySymbol = typeof chartCurrencySymbol === 'undefined' ? $rootScope.currencySymbol: chartCurrencySymbol;
			// Show change calculation.
			// We will show the change if the diff is greater than .25% of orignal value
			if ($scope.delta.value !== 0) {
				var diffPercent = $scope.delta.value / $scope.current.value;
				if (Math.abs(diffPercent) > 0.0025) {
					$scope.showChange = true;
				}
			}

			// Append Status
			if ((metricConfig.goalType === 'Above' && $scope.delta.value > 0) ||
				(metricConfig.goalType === 'Below' && $scope.delta.value < 0)) {
				$scope.delta.status = 'good';
			} else if ($scope.delta.value !== 0) {
				$scope.delta.status = 'bad';
			}
			var valueDecimals = numberOfDecimals($scope.current.value);
			var deltaDecimals = numberOfDecimals($scope.delta.value);
			$scope.current.string = '' + $scope.current.value;
			$scope.delta.string = '' + $scope.delta.value;
			var currentSplit = $scope.current.string.split('.');
			var deltaSplit = $scope.delta.string.split('.');
			var currentValueDecimals = currentSplit.length < 2 ? 0 : currentSplit[1].length;
			var currentDeltaDecimals = deltaSplit.length < 2 ? 0 : deltaSplit[1].length;
			var keepAllValueDecimals = currentValueDecimals < valueDecimals;
			var keepAllDeltaDecimals = currentDeltaDecimals < deltaDecimals;
			valueDecimals = Math.min(valueDecimals, currentValueDecimals);
			deltaDecimals = Math.min(deltaDecimals, currentDeltaDecimals);
			// Append Currencies
			if (metricConfig.displayType === 'currency') {
				if(valueDecimals === 1) {
					valueDecimals = 2;
				}
				if (deltaDecimals === 1) {
					deltaDecimals = 2;
				}
				$scope.current.string = formatterService.formatCurrency($scope.current.value, valueDecimals, currencySymbol, true);
				$scope.delta.string = formatterService.formatCurrency($scope.delta.value, deltaDecimals, currencySymbol, true);
			} else if (metricConfig.displayType === 'percentage') {
				$scope.current.string = formatterService.formatPercent(Math.abs($scope.current.value / 100), valueDecimals);
				$scope.delta.string = formatterService.formatPercent(Math.abs($scope.delta.value / 100), deltaDecimals);
			} else {
				$scope.current.string = formatterService.formatDecimal(Math.abs($scope.current.value), valueDecimals, keepAllValueDecimals);
				$scope.delta.string = formatterService.formatDecimal(Math.abs($scope.delta.value), deltaDecimals, keepAllDeltaDecimals);
			}

			// Append Frequency
			if (metricConfig.displayResolutionType === 'Daily') {
				$scope.delta.string = $scope.delta.string + ' ' + $translate.instant('from yesterday');
			} else if (metricConfig.displayResolutionType === 'Weekly') {
				$scope.delta.string = $scope.delta.string + ' ' + $translate.instant('since {{formattedDate}}', {formattedDate: moment(previousDateKey).format('MMM D, YYYY')});
			} else if (metricConfig.displayResolutionType === 'Monthly') {
				$scope.delta.string = $scope.delta.string + ' ' + $translate.instant('for the last month');
			}
		}

		function findMatchingXPoint(list, date) {
			for (var i = 0; i < list.length; i++) {
				if (list[i].date == date) {
					return i;
				}
			}
			return -1;
		}

		function updateMetricConfig(ndx) {
			metricNdx = ndx;
			var metricModel = $scope.$parent.model;
			if (ndx) {
				metricModel.config.metricNdx = ndx;
			} else {
				delete metricModel.config.metricNdx;
			}
			metricModel.config.crossSiteName = $scope.metric.crossSiteName;
			if (ndx && $scope.useConfig) {
				metricModel.config.axis = {};
				if (!metricModel.config.axis[ndx]) {
					metricModel.config.axis[ndx] = {};
				}
				metricModel.config.axis[ndx].yAxisMinCalcType = $scope.metricMinAxisCalcType;
				metricModel.config.axis[ndx].yAxisMaxCalcType = $scope.metricMaxAxisCalcType;
				metricModel.config.axis[ndx].yAxisMinFixedValue = $scope.metricMinAxisValue;
				metricModel.config.axis[ndx].yAxisMaxFixedValue = $scope.metricMaxAxisValue;
				metricService.updateAxis(metricModel.config.axis[ndx], ndx);
			}
			metricModel.config.summary = !$scope.hideOverview;
			var columnDefinition = $scope.$parent.$parent.col;
			if (ndx != null) {
				storeService.dispatch({
					type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
					payload: {
						column: 'column' + columnDefinition.columnIndex,
						position: columnDefinition.widgets.indexOf(metricModel),
						widget: {
							name: metricModel.config.type,
							config: _.cloneDeep(metricModel.config)
						}
					},
					meta: {
						reportName: undefined,
						reportSettingsId: globalReportName
					}
				});
			}
		}

		$scope.metricChange = function (metricName) {
			if (!metricName) return;
			if (metric !== null) {
				$scope.metric = _.find($scope.uniqueMetrics, {name: metricName});
				$scope.metricName = metricName;
				$scope.$parent.$parent.definition.config.title = metricName;
			}
			$scope.currentValue = 0;
			$scope.delta = {};
			$scope.$parent.$parent.isDrillDown = true;
			$scope.metricChosen = true;
			$scope.$parent.$parent.metricNdx = $scope.metric.ndx;
			getConfigForNdx($scope.metric.ndx);
		};

		function showMinMaxAxisError() {
			$scope.metricForm.minAxisValue.$setValidity('compareWith', false);
			$scope.metricForm.maxAxisValue.$setValidity('compareWith', false);
			$rootScope.$emit('toast', {
				message: 'Min Axis Value must be lower than Max Axis Value',
				success: false,
				time: 5000
			});
		}
		
		$scope.metricAxisCalcType = function (axisType, radioValue) {
			if (radioValue == 'Auto') {
				$scope.metricForm.minAxisValue.$setValidity('minMax', true);
				$scope.metricForm.maxAxisValue.$setValidity('minMax', true);
				$scope.metricForm.minAxisValue.$setValidity('compareWith', true);
				$scope.metricForm.maxAxisValue.$setValidity('compareWith', true);
			} else {
				if ($scope.metricMaxAxisCalcType === 'Fixed' && $scope.metricMinAxisCalcType === 'Fixed' && $scope.metricMinAxisValue > $scope.metricMaxAxisValue) {
					showMinMaxAxisError();
				}
			}
		};

		$scope.saveMetric = function (metric) {
			if (metric !== null) {
				if ($scope.metricMaxAxisCalcType === 'Fixed' && $scope.metricMinAxisCalcType === 'Fixed' && $scope.metricMinAxisValue > $scope.metricMaxAxisValue) {
					showMinMaxAxisError();
				} else {
					$scope.metricForm.minAxisValue.$setValidity('minMax', true);
					$scope.metricForm.maxAxisValue.$setValidity('minMax', true);
					$scope.metricSelect = false;
					$scope.$parent.$parent.hidePencil = false;
					metric.yAxisMinCalcType = $scope.metricMinAxisCalcType;
					metric.yAxisMaxCalcType = $scope.metricMaxAxisCalcType;
					metric.yAxisMinFixedValue = $scope.metricMinAxisValue;
					metric.yAxisMaxFixedValue = $scope.metricMaxAxisValue;
					$scope.useConfig = true;

					if (metric.ndx != metricNdx || $scope.useConfig) {
						pendo.track('widgetChangeConfig', {
							widgetType: type,
							metric: metric.name
						});
						updateMetricConfig(metric.ndx);
						getChart(metric);
					}
				}
			}
		};

		var updateSummaryListener = $rootScope.$on('updateMetricSummary', function (event, data) {
			if ($scope.chartData && data.metricId === $scope.chartData.metricConfig.metricId) {
				formatCurrentAndDelta(data.current, data.delta, data.previousDateKey, $scope.chartData.metricConfig, data.currencySymbol);
			}
		});

		$scope.$on('$destroy', function () {
			updateSummaryListener();
		});

		$scope.$parent.$parent.editWidgetSettings = function () {
			$scope.metricSelect = true;
			$scope.$parent.$parent.hidePencil = true;
		};

		updateEventBind($scope, ['sideBarUpdate', 'metricFilterChanged', 'slideshowViewChanged']);

		var loadData = function () {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView && !$scope.printView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}

				populateMetrics();
			} else {
				$timeout(loadData, 100);
			}
		};

		loadData();
	}
})();
